import styled from 'styled-components'

export const HistoricoWrapper = styled.div`
  background-color: ${({ theme }) => theme.cor53}!important;
  border-radius: 8px;
  padding: 18px;
  gap: 28px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  position: relative;
  width: 100%;

  .mantine-Input-wrapper {
    width: 200px;
  }
`

export const AlertWrapper = styled.div`
  position: absolute;
  right: 50px;
  z-index: 99;
  width: 380px;

  .mantine-Alert-root {
    background: ${({ theme }) => theme.alerta.warning.background};
  }

  .mantine-Alert-message,
  .mantine-Alert-closeButton {
    white-space: normal;
    color: ${({ theme }) => theme.cor9}!important;
  }

  .mantine-Alert-title {
    color: ${({ theme }) => theme.alerta.warning.color};
  }

  svg > path {
    fill: ${({ theme }) => theme.alerta.warning.color};
  }
`

export const Title = styled.div`
  font-family: Roboto;
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
  color: ${({ theme }) => theme.cor9};
`

export const SubTitle = styled.div`
  font-family: Roboto;
  font-size: 14px;
  color: ${({ theme }) => theme.cor8};
  position: absolute;
`

export const DashboardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin: 0 10px;
`
